














































import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { TaskConfig } from '@/type/TaskConfig';
import { ToneConfig } from '@/type/ToneConfig';

//vuex
import MainStore from '@/MainStore'

// components
import PieChart from './PieChart.vue'
import Progress from './Progress.vue';

@Component({
  components: {
    PieChart,
    Progress
  }
})
export default class MainBlock extends Vue {
  // audio DOM
  public $refs!: {
    audio: HTMLMediaElement;
  };

  get audioType() {
    return this.$store.state.MainStore.audioType
  }

  get working(): boolean {
    return this.$store.state.MainStore.working
  }

  get task(): TaskConfig {
    let list: TaskConfig = this.$store.state.taskList.find((item: TaskConfig) => (
      item.isDone === false 
    )) 
    return list
  } // 工作中物件

  get music() {
    let key1 = this.working? '_work' : '_break'
    let key2 = this.working? 'work' : 'break'
    let name: string = this.$store.state[`${key1}`] || '';
    let list: ToneConfig[] = this.$store.state.toneObj[`${key2}`] || [];
    this.audioType === 'play' && this.$nextTick(() => { this.$refs.audio.play(); });
    this.$store.commit('MainStore/SET_AUDIO', this.$refs.audio)
    return list.find((tone: ToneConfig) => tone.title === name) || {
      title: '',
      URL: '',
      select: true
    };
  } // 音樂資料

  mounted() {
    this.$store.registerModule('MainStore', MainStore); // 註冊模組
  }

  completeTaskHandler(event: MouseEvent) {
    const dom: HTMLLabelElement | any = event.currentTarget
    this.$store.commit('FINISH_TASK_ALL', this.task.id)
    this.$store.commit('MainStore/CHANGE_AUDIO_TYPE', 'reset')
    setTimeout(()=>{
      dom.previousElementSibling.checked = false
    }, 1300) // 打勾勾延遲
  } // 完成一組 TASK

  ctrlHandler(type: string) {
    this.$store.commit('MainStore/CHANGE_AUDIO_TYPE', type)
  } // 音樂撥放控制器
}
